import React from 'react';
import { SpaceBackground } from './layers/SpaceBackground';
import { ParallaxStarField } from './layers/ParallaxStarField';
import { Sun } from './layers/Sun';
import { Swamiji } from './layers/Swamiji';
import { Vignette } from './layers/Vignette';

/**
 * Static background layers (reduced-motion / low-end / initial paint). Just the
 * layers — the .hero section and HeroContent live in Hero (index.tsx) so they
 * stay mounted when the background swaps to the animated version (no flicker).
 */
export const StaticHeroLayers: React.FC = () => (
  <>
    <SpaceBackground />
    <ParallaxStarField animate={false} />
    <Sun animate={false} />
    <Swamiji />
    <Vignette />
  </>
);
